import React, { useEffect, useState } from "react";
import BRANDLOGO from '../images/bluebus.png';
import LoginAndSignupModel from "../Components/LoginAndSignupModel";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Link, NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../redux/ActionCreators";





const NavbarComponent = (props) => {
  const dispatch = useDispatch()
  const [showLoginModal, setshowLoginModal] = useState(false);
  const [showLoginMenu, setshowLoginMenu] = useState(false);
  const [loginstate, setloginstate] = useState(false)

  useEffect(() => {
    if (props.userinfo) {
      setloginstate(true);
    }
    else {
      setloginstate(false);
    }

  }, [props.userinfo])
  const handleLogout = () => {
    setshowLoginMenu(false)
    dispatch(logout())
  }

  return (

    <div>
      <div className="flex items-center justify-between bg-[#e7f7fe] lg:px-16 px-5 text-sm font-semibold py-3">
        <Link to="/home" className="cursor-pointer"><img src={BRANDLOGO} className="lg:w-24 lg:h-16 h-12 w-20" alt="Brand Logo" /></Link>
        <div className="flex gap-5 items-center">
          <span className="cursor-pointer">Offers</span>
          <Link to="/mybookings"><span className="cursor-pointer">My Bookings</span></Link>
          {!loginstate ? <span className="cursor-pointer" onClick={() => setshowLoginModal(true)} >Login</span> : <span className="cursor-pointer flex items-center" onClick={() => setshowLoginMenu(!showLoginMenu)}>Account <MdKeyboardArrowDown className="h-5 w-5 text-gray-500" /></span>}
        </div>
      </div>
      {showLoginModal ? <LoginAndSignupModel userinfo={props.userinfo} addUserDetailsToState={props.addUserDetailsToState}
        onClick={(value) => setshowLoginModal(value)} /> : <></>}

      {
        showLoginMenu ?
          <div className="bg-white right-3 top-[3.2rem] absolute lg:top-[3.7rem] lg:right-16 pl-2 pr-2 pt-2 pb-2 rounded-lg">
            <p className="cursor-pointer py-1 pl-2 mb-1 pr-24 rounded-lg hover:bg-[#e7f7fe] font-size-[0.7rem">Trips</p>
            <p className="cursor-pointer py-1 pl-2 mb-1 pr-24 rounded-lg hover:bg-[#e7f7fe] font-size-[0.7rem">Settings</p>
            <p className="cursor-pointer py-1 pl-2 mb-1 pr-24 rounded-lg hover:bg-[#e7f7fe] font-size-[0.7rem" onClick={() => handleLogout()}>Logout</p>
          </div> : <></>
      }
    </div>



  );
};

export default NavbarComponent;
